import { useEffect, useState } from "react"

declare global {
    interface Window {
        grecaptcha?: {
            ready: (cb: () => void) => void
            execute: (siteKey: string, options: { action: string }) => Promise<string>
        }
    }
}

export function useReCaptcha(siteKey: string, action: string = "submit") {
    const [ready, setReady] = useState(false)

    useEffect(() => {
        if (!siteKey) {
            setReady(false)
            return
        }

        const check = () => {
            if (window.grecaptcha && typeof window.grecaptcha.ready === "function") {
                window.grecaptcha.ready(() => {
                    setReady(true)
                })
            }
        }

        check()

        const interval = setInterval(() => {
            if (window.grecaptcha) {
                check()
                clearInterval(interval)
            }
        }, 200)

        return () => clearInterval(interval)
    }, [siteKey])

    const getToken = async (): Promise<string | null> => {
        if (!ready || !window.grecaptcha || !siteKey) return null

        try {
            return window.grecaptcha.execute(siteKey, { action })
        } catch (e) {
            return null
        }
    }

    return { ready, getToken }
}
